module.exports = __webpack_public_path__ + "img/user_footer_logo.282eb402.png";